import { Grid, Step as MuiStep, StepButton, StepLabel, Stepper, Tooltip } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";

import { SessionContext } from "../../Context/SessionContext";
import { StepId, Steps } from "../../Types/Step";

const CustomerStepper: React.FC = () => {
  const {
    bookingDisquals,
    isSavingCustomer,
    isSearchComplete,
    lead,
    step,
    setManualLead,
    setStep,
    setIsSessionShortCircuited
  } = useContext(SessionContext);
  const [displaySteps] = useState(() =>
    // only show steps without conditions, or if conditions are met
    Object.values(Steps).filter(s => !s.getShowStep || s.getShowStep(Boolean(setManualLead), Boolean(lead.outbound)))
  );
  useEffect(() => {
    // if entering interim step, flag the session as no longer being 'short-circuited'.
    if (step.id === StepId.Search) setIsSessionShortCircuited(true);
    else if (!step.isShortCircuit) setIsSessionShortCircuited(false);
  }, [step]);

  return (
    <Grid container direction="column" spacing={1} sx={{ height: "100%" }}>
      <Grid item sx={{ overflow: "hidden", my: 1, width: "100%" }}>
        <Stepper nonLinear activeStep={displaySteps.findIndex(s => s.id === step.id)}>
          {displaySteps.map(step => {
            const disabledReasons = step.getDisabledReasons(isSearchComplete, Boolean(lead.outbound), bookingDisquals);
            const disabled = Boolean(disabledReasons.length) || isSavingCustomer;
            return (
              <Tooltip
                key={step.id}
                title={
                  disabledReasons.length ? (
                    <>
                      <strong>{`The ${step.name} step is disabled for these reasons:`}</strong>
                      {disabledReasons.map((reason, index) => (
                        <div key={index}>{reason}</div>
                      ))}
                    </>
                  ) : (
                    ""
                  )
                }
              >
                <MuiStep disabled={disabled} completed={step.getCompleted && step.getCompleted(isSearchComplete)}>
                  {step.getError && step.getError(isSearchComplete, Boolean(lead.outbound), bookingDisquals) ? (
                    <StepLabel error>{step.name}</StepLabel>
                  ) : (
                    <StepButton disabled={disabled} onClick={() => setStep(Steps[step.id])}>
                      {step.name}
                    </StepButton>
                  )}
                </MuiStep>
              </Tooltip>
            );
          })}
        </Stepper>
      </Grid>
      <Grid item xs sx={{ overflowY: "auto", overflowX: "hidden" }}>
        <step.Component />
      </Grid>
    </Grid>
  );
};
export default CustomerStepper;
